
import { cn } from "@/lib/utils";

interface SpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  variant?: "primary" | "muted";
}

const Spinner = ({ className, size = "md", variant = "primary" }: SpinnerProps) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8",
  };

  const variantClasses = {
    primary: "border-primary border-t-transparent",
    muted: "border-muted-foreground border-t-transparent",
  };

  return (
    <div
      className={cn(
        "animate-spin rounded-full border-4",
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
    />
  );
};

export { Spinner };
